import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import type { ProviderModel } from '@models/types'

interface AddressDetailsProps {
  providerSalesforceDetails: ProviderModel['salesforce_details'],
}

const AddressDetails = (props: AddressDetailsProps) => {
  const { providerSalesforceDetails } = props

  const addressDetailsPayload = [
    { label: 'Address Line 1', value: providerSalesforceDetails?.address_line_1 },
    { label: 'Address Region', value: providerSalesforceDetails?.address_region },
    { label: 'State', value: providerSalesforceDetails?.address_state },
    { label: 'Postcode', value: providerSalesforceDetails?.address_postcode },
  ]

  return (
    <DashboardModule title="Address">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {addressDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}

        <Form.Field label="Country">
          <EntitySelectBox
            data-value-type="number"
            // @ts-expect-error TS2322
            disabled
            entityKey="geoCountries"
            name="geo_country_id"
            sortKey="title"
            value={providerSalesforceDetails?.geo_country_id}
          />
        </Form.Field>
      </Grid>
    </DashboardModule>
  )
}

export default AddressDetails
